import { STATUSES } from '../constants/common';

export default function isPremiumStatus(auth = {}) {
  const {
    data: {
      userStatus: { type },
    },
  } = auth;
  return type === STATUSES.premium;
}
